import { useContext } from 'react';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableRow from '@mui/material/TableRow';
import MuiTableCell from '@mui/material/TableCell';
import { EDStickyTableContext } from '../Contexts/EDStickyTableContext';

export const EDStickyTableRows: React.FC<React.PropsWithChildren> = props => {
  const { bottomSpacing } = useContext(EDStickyTableContext);

  return (
    <MuiTableBody>
      {props.children}
      {Boolean(bottomSpacing) && (
        <MuiTableRow>
          <MuiTableCell
            colSpan={999}
            sx={{ height: bottomSpacing, padding: 0, border: 'none' }}
          />
        </MuiTableRow>
      )}
    </MuiTableBody>
  );
};
